class ViewTag extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.style.display = 'flex';
    this.className = this.getAttribute('class') || this.getAttribute('className');
    // this.updateContent();
    // 添加点击事件监听器
    // console.log(this.onClick, 'cajkc');
    // console.log(this.dataset.ensureclick, 'dsfkj');
    // if (this.onClick || this.dataset.ensureclick) {
    //   this.clickCb = (e) => {
    //     console.log('clicked', this.onClick);
    //     if (typeof this.onClick === 'function') {
    //       this.onClick(e);
    //     }
    //   };
    //   this.addEventListener('click', this.clickCb);
    // }
  }

  disconnectedCallback() {
    if (this.clickCb) {
      this.removeEventListener('click', this.clickCb);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if ((name === 'className' || name === 'class') && (oldValue !== newValue)) {
      this.className = newValue;
    }
  }

  static get observedAttributes() {
    return ['className', 'class'];
  }

  // updateContent() {
  //   if (this.getAttribute('content')) {
  //     this.textContent = this.getAttribute('content');
  //   } else {
  //     const slot = this.querySelector('slot');
  //     if (!slot) {
  //       const newSlot = document.createElement('slot');
  //       this.appendChild(newSlot);
  //     }
  //   }
  // }
}

export default ViewTag;
